import { CORRELATION_ID_KEY } from '@peerless/data-access-search-events';

export { CORRELATION_ID_KEY };

export function getSessionId(): string {
  if (typeof sessionStorage === 'undefined') {
    // Server-side: no stable ID available — callers should only invoke this
    // from client components after hydration.
    return crypto.randomUUID();
  }

  let id = sessionStorage.getItem(CORRELATION_ID_KEY);
  if (!id) {
    id = crypto.randomUUID();
    sessionStorage.setItem(CORRELATION_ID_KEY, id);
  }
  return id;
}
